import '../../Admin/GestionExpert/CompteExpert.scss';

import { ArrowForward } from '@mui/icons-material';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { Alert } from '@mui/material';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import axios from '../../../Api/axios';
import CategoriesSubCategoriesDropDown from '../../../Components/CategoriesSubCategoriesDropDown';
import { buttonStyles, buttonStylesBlue } from '../../../Components/docsAdministrative/JsObjectStyles';
import { TextFieldComponent } from '../../../Components/shared/ReusableSmallComponents';
import SelectRadioBtn from '../../../Components/shared/SelectGender';
import { DELAY, ROLES } from '../../../config';
import { DrawEmailIcon, DrawMan2ExpertStep2 } from '../../../data/SVGs';
import useAuth from '../../../hooks/useAuth';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useCraRdv from '../../../hooks/useCraRdv';
import useFormValidation from '../../../hooks/useFormValidation';
import usePostRequest from '../../../hooks/usePostRequest';
import useRole from '../../../hooks/useRole';
// import useRefreshToken from '../../../hooks/useRefreshToken';
import useUtilities from '../../../hooks/useUtilities';
import useWindowSize from '../../../hooks/useWindowSize';
import UploadImage from '../../../Utils/fileUpload/UploadImage';
import { CompareTwoString, getUrlForAnImage, IMAGE_CONTEXT_ENUM, isHttpStatusSuccess, isUrlFromCompleterProfile, UpperCasePrenomNomFromAuth } from '../../../Utils/utils';
import { isValidEmail } from '../../../Utils/validationUtils';

export const typeTraitementEnum = {
    ADMIN_ADD_EXPERT: 'addAdmin',
    READ_ONLY: 'readOnly',
    ADMIN_UPDATE_EXPERT: 'updateAdmin',
    EXPERT_COMPLETE_PROFILE: 'create',
    EXPERT_UPDATE: 'update',
    // * ESN
    COLLAB_ESN_ADD_DOSSIER_CANDIDAT: 'esnAddDossierCandidat',
    COLLAB_ESN_UPDATE_DOSSIER_CANDIDAT: 'esnUpdateDossierCandidat',
    COLLAB_ESN_ADD_EXPERT: 'esnAddExpert',
    COLLAB_ESN_UPDATE_EXPERT: 'esnUpdateExpert',
};

function DonneesPersonnelsExpert({ typeTraitement ,isDoCandidat}) {

    DonneesPersonnelsExpert.propTypes = {
        typeTraitement: PropTypes.any,
        isDoCandidat:PropTypes.any,
    };

    const { setExpertToBeCreated } = useCraRdv();
    const axiosPrivate = useAxiosPrivate();
    const { device } = useWindowSize();
    const { postData } = usePostRequest();
    let param = useParams();
    const location = useLocation();
    const { isCandidat } = location.state || {}; // destructure the state
    // const refresh = useRefreshToken();
    const navigate = useNavigate();
    const isDossierCandidat= (isDoCandidat ?? isCandidat);
    console.log('param',param,'isDossierCandidat',isDossierCandidat,'para',isCandidat,'isDoCandidat',isDoCandidat);
    const { auth, setAuth } = useAuth();
    const { setShowErrors, errors, setErrors } = useUtilities();
    const { i18n } = useTranslation();
    const [dataExpert, setdataExpert] = useState();
    const [image1, setImage1] = useState(null);
    const [tele, setTele] = useState('');
    const [urlImage, setUrlImage] = useState('');
    const [intitulePoste, setintitulePoste] = useState('');
    const [syntheseProfile, setSyntheseProfile] = useState('');
    const [categorie, setCategorie] = useState('');
    const [sousCategorie, setSousCategorie] = useState('');
    const [firstDataFromBackend, setFirstDataFromBackend] = useState();
    const [messageAlert, setMessageAlert] = useState('');
    const [salarie,setSalarie]=useState('indep');
    const [wasValuesUpdated, setWasValuesUpdated] = useState(true);
    const { setBackdropOpen } = useUtilities();
    const [nom, setNom] = useState('');
    const [prenom, setPrenom] = useState('');
    const [email, setEmail] = useState('');
    const [genre, setGenre] = useState('');//mr
    const role=useRole();
    // const [isDossierCandidat,setIsDossierCandidat]= useState();
    // * Email validation
    // const [isDuplicated, setIsDuplicated] = useState(false);
    // const [emailValid, setEmailValid] = useState(false);
    const [signupErrorEmail, setSignupErrorEmail] = useState('');
    const target = useRef(null);
    // * required field declaration
    // if()
    console.log('typeTraitement',typeTraitement);
    const [isValid4CreateExpert, setIsValid] = (typeTraitement == typeTraitementEnum.ADMIN_ADD_EXPERT || typeTraitement == typeTraitementEnum.COLLAB_ESN_ADD_EXPERT) ? useFormValidation([
        { name: 'genre', value: genre },
        { name: 'prenom', value: prenom },
        { name: 'nom', value: nom },
        { name: 'email', value: email },
        { name: 'intitulePoste', value: intitulePoste },
        { name: 'sousCategorie', value: sousCategorie },
        { name: 'typeExpertEsn', value: salarie },
    ]) : useFormValidation([
        { name: 'intitulePoste', value: intitulePoste },
        { name: 'sousCategorie', value: sousCategorie },
    ]);

    useEffect(() => {
        // ! in odrer to not have a lot of requests {dos}
        if (!email) return;
        if (typeTraitement == typeTraitementEnum.ADMIN_ADD_EXPERT || typeTraitement == typeTraitementEnum.COLLAB_ESN_ADD_EXPERT) {
            setTimeout(() => {
                verifyDuplicated(email);
            }, DELAY);
        }
    }, [email]);

    const authorizedTypes = [
        typeTraitementEnum.ADMIN_ADD_EXPERT,
        typeTraitementEnum.COLLAB_ESN_ADD_EXPERT,
        typeTraitementEnum.COLLAB_ESN_ADD_DOSSIER_CANDIDAT,
    ];

    function isAuthorizedType(typeTraitement) {
        return authorizedTypes.includes(typeTraitement);
    }

    const authorizedUpdateTypes = [
        typeTraitementEnum.READ_ONLY,
        typeTraitementEnum.ADMIN_UPDATE_EXPERT,
        typeTraitementEnum.COLLAB_ESN_UPDATE_EXPERT,
        typeTraitementEnum.COLLAB_ESN_UPDATE_DOSSIER_CANDIDAT
    ];

    function isUpdateAuthorizedType(typeTraitement) {
        return authorizedUpdateTypes.includes(typeTraitement);
    }

    // useEffect(() => {
    //     if(searchParams.get('isDossierCandidat') === 'true' && role=='esn')
    //         setIsDossierCandidat(true);
    //     else if (searchParams.get('isDossierCandidat') === 'false' && role=='esn')
    //         setIsDossierCandidat(false);
    // }, [searchParams]);

    // useEffect(() => {
    //     if(isDossierCandidat)
    //         console.log('isDossierCandidat',isDossierCandidat);
    // }, [isDossierCandidat]);

    useEffect(() => {
        // * si on est sur gestion expert (backOffice visualise les information d un expert)
        if (isUpdateAuthorizedType(typeTraitement))
            getExpertById();
        // * si one est sur completeProfile || si expert veut modifie sur son profil les infos
        // * pour eviter l'appelle de getMyInfo si le backOffice veut ajouter un expert
        if (typeTraitement == typeTraitementEnum.EXPERT_COMPLETE_PROFILE || typeTraitement == typeTraitementEnum.EXPERT_UPDATE) {
            getMyInfos();
            console.log('admin typeTraitement', typeTraitement, 'condition', (typeTraitement != typeTraitementEnum.EXPERT_COMPLETE_PROFILE));
        }
    }, [typeTraitement]);

    useEffect(() => {
        if (dataExpert) {
            setSyntheseProfile(dataExpert?.persoData?.SyntheseProfile);
            setintitulePoste(dataExpert?.persoData?.intitulePoste);
            setTele(dataExpert?.persoData?.tele);
            setNom(dataExpert?.persoData?.nom);
            setPrenom(dataExpert?.persoData?.prenom);
            setGenre(dataExpert?.persoData?.genre);
            setEmail(dataExpert?.persoData?.email);
            setUrlImage(dataExpert?.persoData?.photo);
            setCategorie(dataExpert?.persoData?.categorie?.value);
            setSousCategorie(dataExpert?.persoData?.categorie?.sousCategorie);
            setFirstDataFromBackend(dataExpert);
            setSalarie(dataExpert?.typeExpertEsn);
        }
    }, [dataExpert]);

    const setInitialValue = () => {
        setNom(firstDataFromBackend?.persoData?.nom);
        setGenre(firstDataFromBackend?.persoData?.genre);
        setPrenom(firstDataFromBackend?.persoData?.prenom);
        setSyntheseProfile(firstDataFromBackend?.persoData?.SyntheseProfile ?? '');
        setintitulePoste(firstDataFromBackend?.persoData?.intitulePoste);
        setTele(firstDataFromBackend?.persoData?.tele);
        setUrlImage(firstDataFromBackend?.persoData?.photo);
        if (!firstDataFromBackend?.persoData?.photo)
            setImage1(null);
        setCategorie(firstDataFromBackend?.persoData?.categorie?.value);
        setSousCategorie(firstDataFromBackend?.persoData?.categorie?.sousCategorie);
        setSalarie(firstDataFromBackend?.typeExpertEsn);
        setWasValuesUpdated(true);
    };

    const verifyDuplicated = async (email) => {
        console.log('filled Email \t' + email + ' ++ ' + email);
        axios.post('auth/verifyDuplicated', { email })
            .then(function (response) {
                console.log('email is NOT Duplicated', response);
                // setIsDuplicated(false);
                setIsValid(true);
            })
            .catch(function (error) {
                // setErrors({...errors, })
                setIsValid(false);
                setSignupErrorEmail(error.response.data?.error);
                // setIsDuplicated(true);
                console.log(error.response.data?.error, error.response.status);
            });
    };

    function validateEmail(email) {
        if (!isValidEmail(email)) {
            setSignupErrorEmail('E-mail non valide');
            setIsValid(false);
        }
        else {
            setSignupErrorEmail('');
            setIsValid(true);
        }
    }

    const getMyInfos = async () => {
        try {
            setBackdropOpen(true);
            const response = await axiosPrivate.get('expert/getMyInfos');
            console.log('expergetExpertByIdt data', response?.data);
            setdataExpert(response?.data?.expert);
        } catch (error) {
            console.log(error);
        }
        setBackdropOpen(false);
    };

    const getExpertById = async () => {
        try {
            const response = await axiosPrivate.get('/users/getExpertById/' + param.ExpertId);
            setdataExpert(response.data);
            console.log('response.data', response.data);
        } catch (error) {
            console.log(error);
        }
    };

    const navigateToNextStep = () => {
        if (isUrlFromCompleterProfile(location?.pathname) && auth.completeStep < 2) {
            // * Update the complete step to 2
            setAuth({ ...auth, completeStep: 2 });
        }
        navigate('/expert/completeProfile/step2');
        setBackdropOpen(false);
    };

    // TODO : we shouldn t navigate if the request failed @ AIDA
    const onSubmit = async () => {
        if (tele || syntheseProfile || intitulePoste || sousCategorie) {
            let imageUrl;
            // if there is an image
            if (image1) {
                imageUrl = await getUrlForAnImage(image1, axiosPrivate, IMAGE_CONTEXT_ENUM.expertProfilePic);
            }
            try {
                setBackdropOpen(true);
                updatePersoData({
                    tele,
                    syntheseProfile
                    , intitulePoste,
                    'photo': imageUrl,
                    categorie: {
                        value: categorie,
                        sousCategorie: sousCategorie,
                    },
                    isFromAccountCompletion: isUrlFromCompleterProfile(location?.pathname),
                }, navigateToNextStep);
                target?.current.focus();
                // .then(()=>{} );
            } catch (error) {
                console.log(error);
            }
        }
        else {
            setMessageAlert(i18n.t('Veuillez remplir les champs avant de cliquer sur suivant'));
        }
    };

    const onUpdate = async () => {
        let imageUrl;
        if (image1) {
            imageUrl = await getUrlForAnImage(image1, axiosPrivate, IMAGE_CONTEXT_ENUM.expertProfilePic);
        }
        if (isAuthorizedType(typeTraitement)) {
            updatePersoData({
                typeTraitement, // * we need it to ensure that the backend ensure also email/genre .. are required in the addAdmin case
                role: ROLES.Expert,
                tele,
                syntheseProfile
                , intitulePoste,
                'photo': imageUrl,
                isSalarie: (typeTraitement == typeTraitementEnum.COLLAB_ESN_ADD_DOSSIER_CANDIDAT || typeTraitement == typeTraitementEnum.COLLAB_ESN_UPDATE_DOSSIER_CANDIDAT) ? {}:(salarie=='indep'?false:true),
                genre,
                email: (typeTraitement == typeTraitementEnum.COLLAB_ESN_ADD_DOSSIER_CANDIDAT || typeTraitement == typeTraitementEnum.COLLAB_ESN_UPDATE_DOSSIER_CANDIDAT)?{}:email,
                nom,
                prenom,
                categorie: {
                    value: categorie,
                    sousCategorie: sousCategorie,
                },
                ...((role === 'esn' && isDossierCandidat==true) ? { isDossierCandidat: isDossierCandidat } : {})

            });
        }
        else {
            updatePersoData({
                tele,
                expertId: param.ExpertId,
                syntheseProfile
                , intitulePoste,
                isSalarie : (typeTraitement == typeTraitementEnum.COLLAB_ESN_UPDATE_DOSSIER_CANDIDAT  || isDossierCandidat==true)? {} : (salarie=='indep' ? false : true),
                email: (typeTraitement == typeTraitementEnum.COLLAB_ESN_UPDATE_DOSSIER_CANDIDAT|| isDossierCandidat==true) ? {} : email,
                'photo': imageUrl,
                // isSalarie:salarie=='indep'?{}:true,
                // * to help the backend to do it with atomic way
                genre,
                nom,
                prenom,
                // *
                categorie: {
                    value: categorie,
                    sousCategorie: sousCategorie,
                },
                isFromAccountCompletion: isUrlFromCompleterProfile(location?.pathname),
                ...((role === 'esn' && isDossierCandidat==true) ? { isDossierCandidat: isDossierCandidat } : {})
            });
        }
    };

    const updatePersoData = async (backendObject, navigateToNextStep) => {
        if (isAuthorizedType(typeTraitement)) {
            setExpertToBeCreated({ AddExpertStep1: { url: '/expert/completePersoData', payload: backendObject } });
            console.log('apres suivant',isDossierCandidat);
            // if(role=='esn')
            //     navigate(`/${role}/AddExpertStep2?isDossierCandidat=${isDossierCandidat}`);
            // else
            //     navigate('/admin/AddExpertStep2');
            navigate(`/${role}/AddExpertStep2`,{ state: { isCandidat: isDossierCandidat}},{replace:true});
        }
        else {
            try {
                const response = await postData({ url: '/expert/completePersoData', payload: backendObject });
                if (isHttpStatusSuccess(response.responseStatus)) {
                    setFirstDataFromBackend(response?.data?.expert);
                    setWasValuesUpdated(true);
                    navigateToNextStep();
                }
            } catch (error) {
                console.log(' update error', error);
            }
        }
    };

    return (
        <form className='Frame0DonneesPersonnelsExpert'>
            {typeTraitement != typeTraitementEnum.EXPERT_COMPLETE_PROFILE &&
                <h1 className='TitleHStyle'>{i18n.t('Profil Personnel')}</h1>
            }
            {typeTraitement == typeTraitementEnum.EXPERT_COMPLETE_PROFILE &&
                <h1
                    className='TitleHStyle'
                    style={{ textAlign: device == 'desktop' ? 'start' : 'center' }}
                >{i18n.t('Dites-nous plus sur vous!')}</h1>
            }
            {messageAlert && (<div><Alert severity="error">{messageAlert}</Alert></div>)}

            <div className='rectangleDonneeProfil'>
                <div className='UploadImgDonneePersonnel'>
                    <UploadImage
                        setImage1={setImage1}
                        image1={image1}
                        imageUrl={urlImage}
                        setImageUrl={setUrlImage}
                        typeTraitement={typeTraitement}
                        check={setWasValuesUpdated}
                    />
                    {/* {(device != 'desktop' && (!isAuthorizedType(typeTraitement))) &&
                        <div className='NompreProfile'>
                            {isUpdateAuthorizedType(typeTraitement) ?
                                <h6 className='nomPrenomProfile'>{UpperCasePrenomNomFromAuth(nom, prenom)}</h6>
                                :
                                <h6 className='nomPrenomProfile'>{UpperCasePrenomNomFromAuth(auth?.nom, auth?.prenom)}</h6>
                            }
                            <div className='nomPreProfile'>
                                <div className='frame6Profile'>
                                    <DrawEmailIcon />
                                </div>
                                {isUpdateAuthorizedType(typeTraitement) ?
                                    <p className='frame7Profile'>
                                        {email}
                                    </p>
                                    :
                                    <p className='frame7Profile'>
                                        {auth?.email}
                                    </p>
                                }
                            </div>
                        </div>
                    } */}
                    {(device != 'desktop' && (!isAuthorizedType(typeTraitement))) &&
                        <div className='NompreProfile'>
                            {isUpdateAuthorizedType(typeTraitement) ?
                                <h6 className='nomPrenomProfile'>{UpperCasePrenomNomFromAuth(nom, prenom)}</h6>
                                :
                                <h6 className='nomPrenomProfile'>{UpperCasePrenomNomFromAuth(auth?.nom, auth?.prenom)}</h6>
                            }
                            <div className='nomPreProfile'>
                                <div className='frame6Profile'>
                                    <DrawEmailIcon />
                                </div>
                                {isUpdateAuthorizedType(typeTraitement) ?
                                    <p className='frame7Profile'>
                                        {email}
                                    </p>
                                    :
                                    <p className='frame7Profile'>
                                        {auth?.email}
                                    </p>
                                }
                            </div>
                        </div>
                    }
                </div>
                {device == 'desktop' &&
                    <div style={{ display: 'flex', flexDirection: 'column', height: '195px' }}>
                        <DrawMan2ExpertStep2 />
                    </div>
                }
            </div>
            <div className='GrandBox2Step2DonneePersonnel'>
                <div className='GrandBox2Step2DonneePersonnelPrime'>
                    {/* {(device == 'desktop' && isUpdateAuthorizedType(typeTraitement)) &&
                        <div className='NompreProfile'>
                            {isUpdateAuthorizedType(typeTraitement) ?
                                <h6 className='nomPrenomProfile'>{UpperCasePrenomNomFromAuth(nom, prenom)}</h6>
                                :
                                <h6 className='nomPrenomProfile'>{UpperCasePrenomNomFromAuth(auth?.nom, auth?.prenom)}</h6>
                            }
                            {isDossierCandidat==false &&
                            <div className='nomPreProfile'>
                                <div className='frame6Profile'>
                                    <DrawEmailIcon />
                                </div>

                                    <p className='frame7Profile'>
                                        {email}
                                    </p>

                            </div>}

                        </div>
                    } */}

                    {(device == 'desktop' && !isAuthorizedType(typeTraitement)) &&
                        <div className='NompreProfile'>
                            {isUpdateAuthorizedType(typeTraitement) ?
                                <h6 className='nomPrenomProfile'>{UpperCasePrenomNomFromAuth(nom, prenom)}</h6>
                                :
                                <h6 className='nomPrenomProfile'>{UpperCasePrenomNomFromAuth(auth?.nom, auth?.prenom)}</h6>
                            }
                            {(isUpdateAuthorizedType(typeTraitement) && isDossierCandidat!=true) &&
                            <div className='nomPreProfile'>
                                <div className='frame6Profile'>
                                    <DrawEmailIcon />
                                </div>
                                {isUpdateAuthorizedType(typeTraitement) ?
                                    <p className='frame7Profile'>
                                        {email}
                                    </p>
                                    :
                                    <p className='frame7Profile'>
                                        {auth.email}
                                    </p>
                                }
                            </div>
                            }

                        </div>
                    }

                    <div className='FormStep2ExpertDonneePersonnel'>
                        {(typeTraitement !== typeTraitementEnum.EXPERT_COMPLETE_PROFILE) &&
                            <>
                                <SelectRadioBtn
                                    value={genre}
                                    setValue={setGenre}
                                    name="genre"
                                    options={[
                                        { label: 'Madame', optionValue: 'mme' },
                                        { label: 'Monsieur', optionValue: 'mr' }
                                    ]}
                                    setCheckUpdateValue={setWasValuesUpdated}
                                />

                                {(typeTraitement == typeTraitementEnum.COLLAB_ESN_ADD_EXPERT || typeTraitement == typeTraitementEnum.COLLAB_ESN_UPDATE_EXPERT) &&
                                    <>
                                        <p className='frame8DonneeFacturation'>{i18n.t('Veuillez sélectionner le type')}</p>
                                        <SelectRadioBtn
                                            value={salarie}
                                            setValue={setSalarie}
                                            name="genre"
                                            options={[
                                                { label: 'Salarié', optionValue: 'salarie' },
                                                { label: 'Indépendant', optionValue: 'indep' }
                                            ]}
                                            setCheckUpdateValue={setWasValuesUpdated}
                                        />
                                    </>
                                }

                                <div style={{ alignSelf: 'stretch', display: 'flex', flexDirection: 'row', gap: '8px' }}>
                                    <TextFieldComponent
                                        label={i18n.t('Prénom*')}
                                        value={prenom}
                                        name='prenom'
                                        onChange={(e) => {
                                            if (!CompareTwoString(e.target.value, prenom)) {
                                                setWasValuesUpdated(false);
                                            }
                                            setPrenom(e.target.value);
                                        }}
                                        sx={{
                                            '& > :not(style)': { borderRadius: '8px' },
                                        }}
                                        style={{ background: 'white', width: '50%', borderRadius: '8px' }}
                                    />
                                    <TextFieldComponent
                                        label={i18n.t('Nom*')}
                                        value={nom}
                                        name='nom'
                                        onChange={(e) => {
                                            if (!CompareTwoString(e.target.value, nom)) {
                                                setWasValuesUpdated(false);
                                            }
                                            setNom(e.target.value);
                                        }}
                                        sx={{
                                            '& > :not(style)': { borderRadius: '8px' },
                                        }}
                                        style={{ background: 'white', width: '50%', borderRadius: '8px' }}
                                    />
                                </div>
                            </>
                        }
                        {(typeTraitement == typeTraitementEnum.COLLAB_ESN_ADD_EXPERT|| typeTraitement == typeTraitementEnum.ADMIN_ADD_EXPERT) &&
                            <>
                                <TextFieldComponent
                                    id="email"
                                    label={i18n.t('Email*')}
                                    value={email}
                                    name='email'
                                    onChange={(e) => {
                                        if (!CompareTwoString(e.target.value, email)) {
                                            setWasValuesUpdated(false);
                                        }
                                        setEmail(e.target.value);
                                        validateEmail(e.target.value);
                                    }}
                                    sx={{
                                        '& > :not(style)': { borderRadius: '8px' },
                                    }}
                                    style={{ background: 'white', width: '100%', borderRadius: '8px' }}
                                    // multiline
                                    // maxRows={4}
                                    autoComplete='false'
                                    error={signupErrorEmail == '' ? false : true}
                                    helperText={signupErrorEmail}
                                />
                            </>
                        }
                        <TextFieldComponent
                            label={i18n.t('Intitulé du poste*')}
                            value={intitulePoste}
                            name="intitulePoste"
                            disabled={typeTraitement == typeTraitementEnum.READ_ONLY ? true : false}
                            onChange={(e) => {
                                if (!CompareTwoString(e.target.value, firstDataFromBackend?.persoData?.intitulePoste)) {
                                    setWasValuesUpdated(false);
                                }
                                setintitulePoste(e.target.value);
                            }}
                            sx={{
                                '& > :not(style)': { borderRadius: '8px' },
                            }}
                            style={{ width: '100%', borderRadius: '8px' }}
                        />
                        <TextFieldComponent
                            type="text"
                            name="tele"
                            label={i18n.t('Téléphone')}
                            value={tele}
                            sx={{
                                '& > :not(style)': { borderRadius: '8px' },
                            }}
                            onChange={e => {
                                if (!CompareTwoString(e.target.value, firstDataFromBackend?.persoData?.tele)) {
                                    setWasValuesUpdated(false);
                                }
                                setTele(e.target.value);
                            }}
                            disabled={typeTraitement == typeTraitementEnum.READ_ONLY ? true : false}
                            style={{ background: 'white', width: '100%', borderRadius: '8px' }}
                        />

                        <CategoriesSubCategoriesDropDown
                            setCategorie={setCategorie}
                            setSousCategorie={setSousCategorie}
                            sousCategorie={sousCategorie}
                            check={setWasValuesUpdated}
                            width={'100%'}
                            label={i18n.t('Catégories')}
                            typeTraitement={typeTraitement}
                            name='sousCategorie'
                        />
                        <TextFieldComponent
                            placeholder={i18n.t('Description (facultatif)')}
                            multiline
                            sx={{
                                '& > :not(style)': { borderRadius: '8px' },
                            }}
                            value={syntheseProfile}
                            onChange={(e) => {
                                if (!CompareTwoString(e.target.value, firstDataFromBackend?.persoData?.syntheseProfile)) {
                                    setWasValuesUpdated(false);
                                }
                                setSyntheseProfile(e.target.value);
                            }}
                            disabled={typeTraitement == typeTraitementEnum.READ_ONLY ? true : false}
                            style={{ width: '100%', background: 'white', borderRadius: '8px' }}
                            rows={4}
                            maxRows={5}
                        />
                        {typeTraitement == typeTraitementEnum.EXPERT_COMPLETE_PROFILE &&
                            <div style={{ display: 'flex', flexDirection: device == 'desktop' ? 'row' : 'column', gap: device == 'desktop' ? '0px' : '24px', justifyContent: 'space-between', alignSelf: 'stretch' }}>
                                <Button
                                    variant="outlined"
                                    style={{ ...buttonStyles() }}
                                    onClick={() => navigate('/expert')}
                                >
                                    {i18n.t('Remplir plus tard')}
                                </Button>
                                <Button
                                    variant="contained"
                                    type="submit"
                                    style={{ ...buttonStylesBlue() }}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        if (isValid4CreateExpert) {
                                            onSubmit();
                                            setShowErrors(false);
                                            setErrors({});
                                        }
                                        else setShowErrors(true);
                                    }}
                                    startIcon={<ArrowForward />}
                                >
                                    {i18n.t('Valider')}
                                </Button>
                            </div>
                        }
                        {(typeTraitement == typeTraitementEnum.EXPERT_UPDATE || typeTraitement == typeTraitementEnum.ADMIN_UPDATE_EXPERT || typeTraitement==typeTraitementEnum.COLLAB_ESN_UPDATE_DOSSIER_CANDIDAT || typeTraitement==typeTraitementEnum.COLLAB_ESN_UPDATE_EXPERT) &&
                            <div style={{ display: 'flex', flexDirection: device == 'desktop' ? 'row' : 'column', gap: device == 'desktop' ? '0px' : '24px', justifyContent: 'space-between', alignSelf: 'stretch' }}>
                                <Button
                                    variant="text"
                                    style={{ ...buttonStyles() }}
                                    onClick={() => { setInitialValue(); }}
                                >
                                    {i18n.t('Annuler')}
                                </Button>
                                <Button
                                    variant="contained"
                                    type="submit"
                                    style={{ ...buttonStylesBlue(wasValuesUpdated) }}
                                    //! we must let him know what is wrong .. but we could use the same condition as a second validation
                                    disabled={wasValuesUpdated}
                                    onClick={(e) => {
                                        console.log(2222, isValid4CreateExpert, errors);
                                        e.preventDefault();
                                        if (isValid4CreateExpert) {
                                            onUpdate();
                                            setShowErrors(false);

                                            setErrors({});
                                        }
                                        else setShowErrors(true);
                                    }}
                                    startIcon={<SaveOutlinedIcon />}
                                >
                                    {i18n.t('Sauvegarder')}
                                </Button>
                            </div>
                        }
                        {(isAuthorizedType(typeTraitement) )&&
                            <div style={{ display: 'flex', flexDirection: device == 'desktop' ? 'row' : 'column', gap: device == 'desktop' ? '0px' : '24px', justifyContent: 'flex-end', alignSelf: 'stretch' }}>
                                <Button
                                    variant="contained"
                                    type="submit"
                                    style={{ ...buttonStylesBlue() }}
                                    // disabled={isDuplicated || !emailValid}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        console.log(errors, { ...errors, ...{ email: signupErrorEmail } });
                                        if (signupErrorEmail != '' || !isValid4CreateExpert) {
                                            setShowErrors(true);
                                            setErrors({ ...errors, ...{ email: signupErrorEmail } });
                                            setIsValid(false);
                                        }
                                        else if (isValid4CreateExpert) {
                                            onUpdate();
                                            setShowErrors(false);
                                            setErrors({});
                                        }
                                    }}
                                    startIcon={<ArrowForward />}
                                >
                                    {i18n.t('Suivant')}
                                </Button>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </form>
    );
}
export default DonneesPersonnelsExpert;